/**
 * Microsoft Authentication Library (MSAL) Configuration
 * This file contains the configuration for authenticating with Azure AD
 */
import { Configuration, LogLevel } from '@azure/msal-browser';
import { appConfiguration } from '../../environments/app.config';

/**
 * Azure AD App Registration details
 * Values are loaded from environment-specific configuration files
 */
const scopes = appConfiguration.auth.scopes;

const graphScopes = appConfiguration.auth.graphScopes || [
  'https://graph.microsoft.com/User.Read',
  'https://graph.microsoft.com/User.ReadBasic.All',
];

export const msalConfig: Configuration = {
  auth: {
    clientId: appConfiguration.auth.clientId,
    authority: appConfiguration.auth.authority,
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
    },
  },
};

// Only request graph scopes at login. API scopes (which use .default) cannot
// be combined with resource-specific scopes in a single request per Azure AD.
// API tokens are acquired separately via acquireTokenSilent in AuthClient.ts.
export const loginRequest = {
  scopes: graphScopes,
};

/**
 * Export the scopes for easier access in other files
 */
export { scopes };
